var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2410_31679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8586 24.3984V13.4517H17.5315L18.0825 9.18431H13.8586V6.4602C13.8586 5.22508 14.2002 4.38335 15.9734 4.38335L18.2312 4.38243V0.565513C17.8408 0.514772 16.5004 0.398438 14.9404 0.398438C11.6829 0.398438 9.45276 2.3868 9.45276 6.03756V9.18431H5.76874V13.4517H9.45276V24.3984H13.8586Z",
    fill: "#E3E9EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2410_31679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookDark);
export default __webpack_public_path__ + "static/media/FooterFacebookDark.8eb683fbb4c9ca679bf24a51b11d4fb3.svg";
export { ForwardRef as ReactComponent };